import React, { useEffect, useRef } from "react";
import { postTrackingLogger } from "../../services/offers/offers.service";

interface LayoutErrorProps {
  message: string;
  companyId: string;
  placementId: string;
  campaignId: string;
  templateId: string;
  layoutId: string;
  page: string;
}

const LayoutError = ({
  message,
  companyId,
  placementId,
  campaignId,
  templateId,
  layoutId,
  page,
}: LayoutErrorProps) => {
  const refOffers = useRef<HTMLDivElement | null>(null);

  const errorPopupRef = useRef<HTMLDivElement>(null);

  const handleCloseErrorWrapper = () => {
    window.top?.postMessage({ event: "closeMainIframe", load: "" }, "*");
    window.top?.postMessage({ event: "setIframeSizeBack", load: "" }, "*");
    window.top?.postMessage(
      { event: "setEmbeddedIframeSizeBack", load: "" },
      "*"
    );
  };

  const handleClickErrorWrapper = (event: React.MouseEvent<HTMLElement>) => {
    if (
      event.target instanceof Node &&
      !refOffers.current?.contains(event.target) &&
      !errorPopupRef.current?.contains(event.target)
    ) {
      handleCloseErrorWrapper();
    }
  };

  useEffect(() => {
    const _initClosing = setTimeout(() => {
      postTrackingLogger({
        message,
        companyId,
        placementId,
        campaignId,
        templateId,
        layoutId,
        page,
        feature: "tmpl",
      });
      handleCloseErrorWrapper();
    }, 1e3);

    return () => clearTimeout(_initClosing);
    /* eslint-disable-next-line react-hooks/exhaustive-deps */
  }, []);

  return (
    <>
      <div
        id="error-popup-wrapper"
        onClick={handleClickErrorWrapper}
        className="error-popup-wrapper"
      >
        <div className={`opl-wrapper opl-wrapper-center`}>
          <div ref={errorPopupRef} className="error-popup">
            <div className="content-panel">
              <div className="error-popup">
                <svg
                  onClick={() => handleCloseErrorWrapper()}
                  className="email-close"
                  width="12"
                  height="12"
                  viewBox="0 0 12 12"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M1.12634 1.12829C1.4276 0.827028 1.91604 0.827028 2.2173 1.12829L6.30039 5.21138L10.3835 1.12829C10.6847 0.827028 11.1732 0.827028 11.4744 1.12829C11.7757 1.42955 11.7757 1.91799 11.4744 2.21925L7.39136 6.30234L11.4744 10.3854C11.7757 10.6867 11.7757 11.1751 11.4744 11.4764C11.1732 11.7777 10.6847 11.7777 10.3835 11.4764L6.30039 7.39331L2.2173 11.4764C1.91604 11.7777 1.4276 11.7777 1.12634 11.4764C0.825075 11.1751 0.825075 10.6867 1.12634 10.3854L5.20943 6.30234L1.12634 2.21925C0.825075 1.91799 0.825075 1.42955 1.12634 1.12829Z"
                    fill="#A3A8B9"
                  />
                </svg>

                <h4>Something went wrong</h4>
                <span onClick={handleCloseErrorWrapper}>Close now</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default LayoutError;
